import { observer } from 'mobx-react-lite'
import __select from './__select.controller'
import { Row, Col, Select, Button, Input, Space, Table, Image } from "antd";
import React, { useEffect, useState } from 'react'
import i from '../../translations/i'
import { CustomProductListsLayout } from '../../front/catalog/custom_product_lists/CustomProductListsLayout'
import { __group } from '../../front/catalog/groups/__group'
import { PickedProducts, ProductPicker } from '../../components/product_table/ProductPicker'

export const SelectEntity = observer(({ type, element, none = true, elements = [], item_element = null, types = [] }: any) => {

    useEffect(() => {
        if(!none) __select.setTypesElements()
        __select.setType(type ? type : '', element)
        __select.select.element = item_element
    }, [])

    return (
        <>
            <Row gutter={[20, 20]}>
                <Col span={24}>
                    <label className="formLabel">{i.t('def:select_link_type')}</label>
                    <Select
                        style={{ width: `100%` }}
                        options={types.length > 0 ? __select.types.filter((el: any) => types.findIndex((l: any) => el.value === l) === -1) : __select.types}
                        onChange={(e) => __select.setType(e)}
                        value={__select.select.type}
                    />
                </Col>
                <Col span={24}>
                    {__select.select.type === 'category' && <SelectCategories elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'product_group' && <SelectGroup elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'article' && <SelectNews elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'article_categories' && <SelectArticleCategories elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'product' && <SelectProduct elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'custom_product_list' && <CustomProductListsLayout type="group" multiple={false} selectedElements={[item_element]} />}
                    {__select.select.type === 'contacts' && <SelectContact elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'place' && <SelectPoints elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'places_group' && <SelectPointsGroup elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'feedback' && <SelectFeedback elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'forms' && <SelectForm elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'promo' && <SelectPromo elementID={__select.select.value} element={item_element} />}
                    {__select.select.type === 'calendar' && <SelectCalendar elementID={__select.select.value} element={item_element} />}

                    {(__select.select.type === 'url' || __select.select.type === 'url_blank') &&
                        <Input onChange={(e) => __select.select.value = e.target.value} value={__select.select.value} />
                    }

                </Col>
            </Row>
        </>
    )
})

export const SelectArticleCategories = observer(({ elementID, element = null }: any) => {

  useEffect(() => {
    __select.getArticleCategories()
  }, [])

  const columns = [
    {
      title: "ID",
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: i.t('news:name'),
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: i.t('news:actions'),
      render: (record: any) =>
        <Space>
          <Button
            type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
            onClick={() => {
              __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)
              __select.setElement(`${elementID}` === `${record.id}` ? [] : record)
            }}
          >
            {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
          </Button>
          {record.subcategories
            &&
            <Button
              type="dashed"
              onClick={() => __select.getArticleCategories(record.id, true)}
            >
              {i.t('def:jump.jump')}
            </Button>
          }
        </Space>
    },
  ]

  return(
    <>
      {element &&
        <>
          <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.name}</label>
        </>
      }
      <label className="label_default">{i.t('def:select_news')}</label>
      <br/>
      <Button
        type={elementID === '' ? 'primary' : 'dashed'}
        onClick={() => __select.setValue('')}
      >{i.t('def:jump.news')}</Button>

      {__select.categoryID > 0 && <Button onClick={() => __select.getArticleCategories(null, true)}>{i.t('def:return_main_category')}</Button>}

      <br/><br/>
      <Table
        columns={columns}
        dataSource={__select.list}
        pagination={{
          position: ['bottomLeft'],
          hideOnSinglePage: true,
          current: Number(__select.page),
          pageSize: __select.limit,
          total: __select.total,
          showSizeChanger: false,
          onChange: (e) => {
            __select.setPage(e)
            __select.getArticleCategories()
          }
        }}
      />
    </>
  )

})

const SelectNews = observer(({ elementID, element = null }: any) => {

    useEffect(() => {
        __select.getArticles()
    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: i.t('news:view'),
            dataIndex: 'enabled',
            key: 'enabled'
        },
        {
            title: i.t('news:name'),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: i.t('news:actions'),
            render: (record: any) =>
                <Button
                    type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
                    onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
                >
                    {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
                </Button>
        },
    ]

    return(
        <>
            {element &&
                <>
                    <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.name}</label>
                </>
            }
            <label className="label_default">{i.t('def:select_news')}</label>
            <br/>
            <Button
                type={elementID === '' ? 'primary' : 'dashed'}
                onClick={() => __select.setValue('')}
            >{i.t('def:jump.news')}</Button>
            <br/><br/>
          <Row>
            <Col span={24}>
              <Input
                onChange={(e) => {
                  __select.setPage(1)
                  __select.filter.name = e.target.value
                  __select.getArticles()
                }}
                placeholder={i.t('selectEntity:searchByName')}
              />
            </Col>
          </Row>
          <br/>
            <Table
                columns={columns}
                dataSource={__select.list}
                pagination={{
                    position: ['bottomLeft'],
                    hideOnSinglePage: true,
                    current: Number(__select.page),
                    pageSize: __select.limit,
                    total: __select.total,
                    showSizeChanger: false,
                    onChange: (e) => {
                        __select.setPage(e)
                        __select.getArticles()
                    }
                }}
            />
        </>
    )
})

const SelectGroup = observer(({ elementID, element = null }: any) => {
    useEffect(() => {
      __select.page = 1
        __group.getList()
    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: i.t('def:name'),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: i.t('def:actions.action'),
            render: (record: any) =>
                <Button
                    type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
                    onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
                >
                    {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
                </Button>
        },
    ]

    return(
        <>
            {element &&
                <>
                    <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.name}</label>
                </>
            }
            <Table
                columns={columns}
                dataSource={__group.list}
                pagination={{
                    position: ['bottomLeft'],
                    hideOnSinglePage: true,
                    current: Number(__group.pagination.page),
                    pageSize: __group.pagination.limit,
                    total: __group.pagination.total,
                    showSizeChanger: false,
                    onChange: (e) => {
                        __group.setPage(e)
                        __group.getList()
                    }
                }}
            />
        </>
    )
})

// Выбор одного товара: таблица товаров каталога в режиме выбора. elementID — id выбранного товара,
// element — его карточка, если экран её знает (иначе берём ту, что выбрали в этой модалке)
export const SelectProduct = observer(({ elementID, element = null }: any) => {
    const selectedId = Number(elementID) || null
    const product = [__select.select.element, element].find((el: any) => el && typeof el === 'object' && Number(el.id) === selectedId) ?? null

    return (
        <>
            <PickedProducts
                title={selectedId ? i.t('productCards:pickedOne') : i.t('productCards:pickedNone')}
                items={selectedId ? [{ id: selectedId, product }] : []}
                onRemove={() => __select.setValue('')}
            />
            <ProductPicker
                selectedIds={selectedId ? [selectedId] : []}
                onToggle={(record: any, selected: boolean) => __select.setValue(selected ? record.id : '', selected ? record : null)}
            />
        </>
    )
})

// Выбор нескольких товаров. elementID — выбранные id (у списков товаров, custom, — {id, sorting} с ручным порядком),
// elements — карточки уже выбранных товаров, returnFunction — вызывается при добавлении товара,
// visible — показывать ли выбранные товары списком (иначе экран показывает их у себя)
export const SelectProducts = observer(({ elementID, elements = [], visible = true, returnFunction = null, custom = false }: any) => {
    // Карточки товаров, выбранных в этой модалке: в elements их ещё нет
    const [picked] = useState(() => new Map<number, any>())

    const values: any[] = elementID ?? []
    // Порядок списка товаров — по sorting, как его сохранит бэкенд (так же сортирует __select.changePosition)
    const ordered = custom
        ? [...values].sort((a: any, b: any) => ((a.sorting ?? 500) - (b.sorting ?? 500)) || (a.id - b.id))
        : values
    const ids: number[] = ordered.map((el: any) => Number(custom ? el.id : el))

    const known = (id: number) => (elements ?? []).find((el: any) => Number(el?.id) === id) ?? picked.get(id) ?? null
    const toggle = (record: any) => __select.setValueMultiple(record.id, record, returnFunction, custom)

    return (
        <>
            <PickedProducts
                title={i.t('productCards:pickedCount', { count: ids.length })}
                items={visible ? ids.map(id => ({ id, product: known(id) })) : undefined}
                empty={i.t('productCards:pickedEmpty')}
                onReset={ids.length > 0 ? () => __select.setValueArray([]) : undefined}
                onRemove={id => toggle(known(id) ?? { id })}
                onMove={custom ? (id, direction) => __select.changePosition(id, direction) : undefined}
            />
            <ProductPicker
                selectedIds={ids}
                onToggle={(record: any) => {
                    picked.set(Number(record.id), record)
                    toggle(record)
                }}
            />
        </>
    )
})

const SelectContact = observer(({ elementID, element = null }: any) => {

    useEffect(() => {
      __select.page = 1
        __select.getContacts()
    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: i.t('def:name'),
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: i.t('def:type'),
            dataIndex: 'type',
            key: 'type'
        },
        {
            title: i.t('def:value'),
            dataIndex: 'value',
            key: 'value'
        },
        {
            title: i.t('news:actions'),
            render: (record: any) =>
                <Button
                    type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
                    onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
                >
                    {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
                </Button>
        },
    ]

    return(
        <>
            {element &&
                <>
                    <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.title}</label>
                </>
            }
            <label className="label_default">{i.t('def:select_contact')}</label>
            <br/>
            <Button
                type={elementID === '' ? 'primary' : 'dashed'}
                onClick={() => __select.setValue('')}
            >{i.t('def:jump.contacts')}</Button>
            <br/><br/>
            <Table
                columns={columns}
                dataSource={__select.list}
                pagination={false}
            />
        </>
    )
})

const SelectPoints = observer(({ elementID, element = null }: any) => {

    useEffect(() => {
      __select.page = 1
        __select.getPoints()
    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: i.t('def:name'),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: i.t('news:actions'),
            render: (record: any) =>
                <Button
                    type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
                    onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
                >
                    {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
                </Button>
        },
    ]

    return(
        <>
            {element &&
                <>
                    <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.name}</label>
                </>
            }
            <label className="label_default">{i.t('def:select_depart')}</label>
            <br/>
            <Button
                type={elementID === '' ? 'primary' : 'dashed'}
                onClick={() => __select.setValue('')}
            >{i.t('def:jump.depart')}</Button>
            <br/><br/>
            <Table
                columns={columns}
                dataSource={__select.list}
                pagination={{
                    position: ['bottomLeft'],
                    hideOnSinglePage: true,
                    current: Number(__select.page),
                    pageSize: __select.limit,
                    total: __select.total,
                    showSizeChanger: false,
                    onChange: (e) => {
                        __select.setPage(e)
                        __select.getPoints()
                    }
                }}
            />
        </>
    )
})

const SelectPointsGroup = observer(({ elementID, element = null }: any) => {

    useEffect(() => {
      __select.page = 1
        __select.getPointsGroups()
    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: i.t('def:name'),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: i.t('news:actions'),
            render: (record: any) =>
                <Button
                    type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
                    onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
                >
                    {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
                </Button>
        },
    ]

    return(
        <>
            {element &&
                <>
                    <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.name}</label>
                </>
            }
            <label className="label_default">{i.t('def:Select Places Group')}</label>
            <br/>
            <Button danger onClick={() => __select.setValue('')}>{i.t('def:reset')}</Button>
            <br/><br/>
            <Table
                columns={columns}
                dataSource={__select.list}
                pagination={{
                    position: ['bottomLeft'],
                    hideOnSinglePage: true,
                    current: Number(__select.page),
                    pageSize: __select.limit,
                    total: __select.total,
                    showSizeChanger: false,
                    onChange: (e) => {
                        __select.setPage(e)
                        __select.getPointsGroups()
                    }
                }}
            />
        </>
    )
})

const SelectFeedback = observer(({ elementID, element = null }: any) => {

    useEffect(() => {
      __select.page = 1
        __select.getFeedback()
    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: i.t('def:name'),
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: i.t('news:actions'),
            render: (record: any) =>
                <Button
                    type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
                    onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
                >
                    {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
                </Button>
        },
    ]

    return(
        <>
            {element &&
                <>
                    <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.title}</label>
                </>
            }
            <label className="label_default">{i.t('def:select_feedback')}</label>
            <br/>
            <Button
                type={elementID === '' ? 'primary' : 'dashed'}
                onClick={() => __select.setValue('')}
            >{i.t('def:jump.feedback')}</Button>
            <br/><br/>
            <Table
                columns={columns}
                dataSource={__select.list}
                pagination={{
                    position: ['bottomLeft'],
                    hideOnSinglePage: true,
                    current: Number(__select.page),
                    pageSize: __select.limit,
                    total: __select.total,
                    showSizeChanger: false,
                    onChange: (e) => {
                        __select.setPage(e)
                        __select.getFeedback()
                    }
                }}
            />
        </>
    )
})

const SelectForm = observer(({ elementID, element = null }: any) => {

    useEffect(() => {
      __select.page = 1
        __select.getForm()
    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: i.t('def:name'),
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: i.t('news:actions'),
            render: (record: any) =>
                <Button
                    type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
                    onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
                >
                    {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
                </Button>
        },
    ]

    return(
        <>
            {element &&
                <>
                    <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.title}</label>
                </>
            }
            <label className="label_default">{i.t('def:select_form')}</label>
            <br/>
            <Button
                type={elementID === '' ? 'primary' : 'dashed'}
                onClick={() => __select.setValue('')}
            >{i.t('def:jump.forms')}</Button>
            <br/><br/>
            <Table
                columns={columns}
                dataSource={__select.list}
                pagination={{
                    position: ['bottomLeft'],
                    hideOnSinglePage: true,
                    current: Number(__select.page),
                    pageSize: __select.limit,
                    total: __select.total,
                    showSizeChanger: false,
                    onChange: (e) => {
                        __select.setPage(e)
                        __select.getForm()
                    }
                }}
            />
        </>
    )
})

export const SelectCategories = observer(({ elementID, element = null, type = 'jump' }: any) => {

    useEffect(() => {
      __select.page = 1
        __select.getCategories()

    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'value',
            key: 'value'
        },
      {
        title: "",
        dataIndex: 'image',
        key: 'image',
        render: (e: string) => <Image
          width={'100px'}
          src={e}
        />
      },
        {
            title: i.t('def:name'),
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: i.t('news:actions'),
            render: (record: any) =>
                <Space>
                    <Button
                        type={`${elementID}` === `${record.value}` ? 'primary' : 'dashed'}
                        onClick={() => {
                            __select.setValue(`${elementID}` === `${record.value}` ? '' : record.value)
                            __select.setElement(`${elementID}` === `${record.value}` ? [] : record)
                        }}
                    >
                        {`${elementID}` === `${record.value}` ? i.t('def:selected') : i.t('def:select')}
                    </Button>
                    {record.subcategory &&
                        <Button
                            type="dashed"
                            onClick={() => __select.getCategories(record.value, true)}
                        >
                            {i.t('def:jump.jump')}
                        </Button>
                    }
                </Space>
        },
    ]

    return(
        <>
            {element &&
                <>
                    <label className="label_default">{i.t('def:selected')}: {element.name}</label>
                </>
            }
            <label className="label_default">{i.t('def:select_category')}</label>
            <br/>
            <Space>
                <Button
                    type={elementID === '' ? 'primary' : 'dashed'}
                    onClick={() => {
                        __select.setValue('')
                        __select.setElement([])
                    }}
                >
                    {type === 'custom_list' ? (<>{i.t('def:reset')}</>) : (<>{i.t('def:jump.category')}</>)}
                </Button>
                {__select.categoryID > 0 && <Button onClick={() => __select.getCategories(0, true)}>{i.t('def:return_main_category')}</Button>}
            </Space>
            <br/><br/>
            <Table
                columns={columns}
                dataSource={__select.list}
                pagination={{
                    position: ['bottomLeft'],
                    hideOnSinglePage: true,
                    current: Number(__select.page),
                    pageSize: __select.limit,
                    total: __select.total,
                    showSizeChanger: false,
                    onChange: (e) => {
                        __select.setPage(e)
                        __select.getCategories(__select.categoryID)
                    }
                }}
            />
        </>
    )
})

export const SelectStatus = observer(({ elementID }: any) => {

    useEffect(() => {
      __select.page = 1
        __select.getStatuses()
    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: i.t('def:name'),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: i.t('news:actions'),
            render: (record: any) =>
                <Space>
                    <Button
                        type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
                        onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
                    >
                        {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
                    </Button>
                </Space>
        },
    ]

    return(
        <>
            <label className="label_default">{i.t('def:Select Status')}</label>
            <br/>
            <Space>
                <Button
                    type={elementID === '' ? 'primary' : 'dashed'}
                    onClick={() => __select.setValue('')}
                >
                    {i.t('def:jump.category')}
                </Button>
            </Space>
            <br/><br/>
            <Table
                columns={columns}
                dataSource={__select.list}
                pagination={{
                    position: ['bottomLeft'],
                    hideOnSinglePage: true,
                    current: Number(__select.page),
                    pageSize: __select.limit,
                    total: __select.total,
                    showSizeChanger: false,
                    onChange: (e) => {
                        __select.setPage(e)
                        __select.getStatuses()
                    }
                }}
            />
        </>
    )
})

export const SelectPromo = observer(({ elementID, element = null }: any) => {

    useEffect(() => {
      __select.page = 1
        __select.getPromo()
    }, [])

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: i.t('def:name'),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: i.t('news:actions'),
            render: (record: any) =>
                <Space>
                    <Button
                        type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
                        onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
                    >
                        {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
                    </Button>
                </Space>
        },
    ]

    return(
        <>
            {element &&
                <>
                    <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.name}</label>
                </>
            }
            <label className="label_default">{i.t('def:select_promo')}</label>
            <br/>
            <Space>
                <Button
                    type={elementID === '' ? 'primary' : 'dashed'}
                    onClick={() => __select.setValue('')}
                >
                    {i.t('def:jump.promo')}
                </Button>
            </Space>
            <br/><br/>
            <Table
                columns={columns}
                dataSource={__select.list}
                pagination={{
                    position: ['bottomLeft'],
                    hideOnSinglePage: true,
                    current: Number(__select.page),
                    pageSize: __select.limit,
                    total: __select.total,
                    showSizeChanger: false,
                    onChange: (e) => {
                        __select.setPage(e)
                        __select.getPromo()
                    }
                }}
            />
        </>
    )
})

export const SelectCalendar = observer(({ elementID, element = null }: any) => {

  useEffect(() => {
    __select.page = 1
    __select.getCalendars()
  }, [])

  const columns = [
    {
      title: "ID",
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: i.t('def:name'),
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: i.t('news:actions'),
      render: (record: any) =>
        <Space>
          <Button
            type={`${elementID}` === `${record.id}` ? 'primary' : 'dashed'}
            onClick={() => __select.setValue(`${elementID}` === `${record.id}` ? '' : record.id)}
          >
            {`${elementID}` === `${record.id}` ? i.t('def:selected') : i.t('def:select')}
          </Button>
        </Space>
    },
  ]

  return(
    <>
      {element &&
        <>
          <label className="label_default">{i.t('def:selected')}: #{element.id} - {element.name}</label>
        </>
      }
      <label className="label_default">{i.t('def:Select calendar')}</label>
      <br/>
      <br/><br/>
      <Table
        columns={columns}
        dataSource={__select.list}
        pagination={{
          position: ['bottomLeft'],
          hideOnSinglePage: true,
          current: Number(__select.page),
          pageSize: __select.limit,
          total: __select.total,
          showSizeChanger: false,
          onChange: (e) => {
            __select.setPage(e)
            __select.getPromo()
          }
        }}
      />
    </>
  )
})